import React, { Component } from 'react';
import Parse from 'parse';
import {Link, Redirect } from "react-router-dom";
import ParseEditableInput from './components/parseEditableInput'

export default class NewUnit extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }

  nameChange = (e) => {
    var value = e.target.value;
    this.setState({
      name:value
    })
  }

  unitChange = (e) => {
    var value = e.target.value;
    this.setState({
      unit:value
    })
  }

  save = () => {
    var Query = Parse.Object.extend("Units");
    var item = new Query();
    item.set("name",this.state.name);
    item.set("unit",this.state.unit);
    item.save(null, {
      success: (data) =>{
        this.setState({
          done:true
        })
      },
      error:(error) => {
        alert('Failed to create new object, with error code: ' + error.message);
      }
    });
  }
  render() {
    if(this.state.done) return <Redirect to={'/units'}/>
    return (
      <div>
        <div className="row">
          <div className="back-button">
            <Link to={'/'}>
              <img className="full-width" src="img/back-black.png" />
            </Link>
          </div>
        </div>
        <div className="max-width-container medium-left-padding">
          <h1 className="no-margin uppercase">{'New Unit'}</h1>
          <div className="medium-top-margin">
            <h2>Name</h2>
            <div className="tiny-padding">
              <input
                type="text"
                value={this.state.name}
                onChange={this.nameChange}
              placeholder="Name" />
            </div>
          </div>
          <div className="medium-top-margin">
            <h2>Unit</h2>
            <div className="tiny-padding">
              <input
                type="text"
                value={this.state.unit}
                onChange={this.unitChange}
              placeholder="20-1" />
            </div>
          </div>
          <div className="tiny-padding">
            <div className="button primary-background white" onClick={this.save}>Save</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/newUnit.js